module.exports = __webpack_public_path__ + "media/images/icons/teacher-icon-250be596943b7601a1d0eaa830f90c6e.svg";